import { Flex, Text } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

export const directLeadColumn = [
  {
    Header: "ID",
    accessor: "_id",
    Cell: ({ value }) => <Text>{value}</Text>,
  },
  {
    Header: "OWNER",
    accessor: "user_data",
    Cell: ({ value }) => (
      <Text>
        {value.first_name} {value.last_name}
      </Text>
    ),
  },
  {
    Header: "PHONE",
    accessor: "user_data.phone",
    Cell: ({ value }) => {
      return (
        <Flex gap={1} align="center" justify={"center"}>
          <a href={`/#/admin/users?search_text=${value}`}>{value}</a>
        </Flex>
      );
    },
  },
  {
    Header: "LEAD",
    accessor: "lead_data",
    Cell: ({ value }) => {
      const name = `${value?.first_name || ""} ${value?.last_name || ""}`.trim();
      const phone = value?.phone;
      if (!name && !phone) return <Text>-</Text>;
      return (
        <Flex direction="column" align="center" justify="center">
          <Text>{name || "-"}</Text>
          {phone && (
            <a href={`/#/admin/users?search_text=${phone}`}>
              <Text fontSize="xs" color="blue.500">{phone}</Text>
            </a>
          )}
        </Flex>
      );
    },
  },
  {
    Header: "VIEWED",
    accessor: "viewed",
    Cell: ({ value }) => (
      <>{value ? <StatusBadge bgColor="green" label="Viewed" /> : "-"}</>
    ),
  },
  {
    Header: "AD TYPE",
    accessor: "requirement_data",
    Cell: ({ value }) => {
      const { ad_type, shared_accommodation_interest } = value || {};
      let text = ad_type;
      if (shared_accommodation_interest) text += ` (CO-LIVING)`;
      return (
        <Flex gap={1} align="center" justify={"center"}>
          <a target="_blank" href={`/#/admin/user-requirements?requirement_id=${value._id}`}>
            {text || "-"}
          </a>
        </Flex>
      );
    },
  },
  {
    Header: "PROPERTY TYPE",
    accessor: "requirement_data.property_type",
    Cell: ({ value }) => <Text>{value || "-"}</Text>,
  },
  {
    Header: "LOCATION",
    accessor: "requirement_data.location",
    Cell: ({ value }) => {
      const { locality, city } = value || {};
      let text = `${locality ? `${locality}, ` : ""}${city}`;
      return <Text>{text || "-"}</Text>;
    },
  },
  {
    Header: "SENT ON",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
];
